import makeStyles from "@material-ui/core/styles/makeStyles";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import * as React from "react";

const useStyles = makeStyles(
  () => ({
    checkIcon: {
      color: "#00c6a2",
      marginBottom: "-6px",
      marginRight: "3px"
    },
    crossIcon: {
      color: "#ec5d77",
      marginBottom: "-6px",
      marginRight: "3px"
    },
    greenLabel: {
      color: "#00c6a2",
      fontSize: "15px",
      fontWeight: 600
    },
    redLabel: {
      color: "#ec5d77",
      fontSize: "15px",
      fontWeight: 600
    }
  }),
  {
    name: "Cutlery"
  }
);

export interface CulteryProps {
  hasCutlery: boolean;
}

const Cutlery: React.SFC<CulteryProps> = props => {
  const classes = useStyles(props);

  return (
    <>
      {props.hasCutlery ? (
        <div>
          <CheckCircleIcon className={classes.checkIcon} />
          <span className={classes.greenLabel}>Cutlery Requested</span>
        </div>
      ) : (
        <div>
          <CancelIcon className={classes.crossIcon} />
          <span className={classes.redLabel}>No Cutlery</span>
        </div>
      )}
    </>
  );
};

export default Cutlery;
